<script setup>
import {onMounted, ref} from "vue";
import router from "../../router.js";
import {forgottenPassword} from '@/services/AuthService';
import {getTenantData} from '@/services/TenantService';
import Footer from '@/components/layouts/Footer.vue';
import {setButtonContentDefault, setButtonContentLoading, setButtonContentSuccess, showSuccessMessage} from '@/helper';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const theme = ref({});
const email = ref('');
const errorMessage = ref('');

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  email.value = urlParams.get('email');

  getTenantData()
      .then((response) => {
        theme.value = response.theme;
      });
});

const submit = () => {
  setButtonContentLoading('btn-login');
  forgottenPassword(email.value).then(response => {
    if (response.message === 'auth.reset_password_email_sent_if_user_exists') {
      setButtonContentSuccess('btn-login');
      showSuccessMessage(t('forgottenPassword.email_with_password_reset_sent'));
    }
    router.push('/login');
  },(error) => {
    errorMessage.value = error.message;
    if (error.message === 'global.not_found') {
      errorMessage.value = t('orgottenPassword.user_not_found');
    }
    setButtonContentDefault('btn-login');
  });
}

</script>

<template>
  <div class="entrance">
    <header class="entrance__header"></header>
    <div class="min-vh-device row justify-content-center align-items-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-4">
        <div class="entrance__logo" v-if="theme && theme.logoBase64">
          <img :src="theme.logoBase64" v-if="theme && theme.logoBase64" alt="" />
        </div>
        <div class="entrance__title">
          {{ t('forgottenPassword.password_reset') }}
        </div>
        <div class="entrance__content">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="submit">
                <div class="form-group">
                  <label class="form-label" for="email">{{ t('forgottenPassword.email:') }}</label>
                  <input id="email" class="form-control"
                         type="email" placeholder="" autocomplete="off"
                         v-model="email" required/>
                </div>
                <div class="form-group">
                  <button id="btn-login" type="submit" class="btn btn-primary w-100">
                    <span>{{ t('forgottenPassword.reset_password') }}</span>
                  </button>
                  <div class="alert alert-danger mt-3" v-if="errorMessage"> {{errorMessage}} </div>
                </div>
                <div class="form-group form-group--footer-text">
                  <router-link to="/login">{{ t('forgottenPassword.back_to_login') }}</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
